import { openModal } from '@core/components/ModalStack';
import { MoveFileOrgModalProps } from './MoveFileOrgModal';

export async function openFileOrgModal(props: MoveFileOrgModalProps) {
  const { MoveFileOrgModal } = await import('./MoveFileOrgModal');

  openModal(MoveFileOrgModal, props);
}
